$.loader = {
    loader: null,

    init: function(container) {
        this.loader = ReactDOM.render(
            React.createElement(
                "div",
                {"className": "m-loader"},
                ""),
            container
        );

        return this
    },

    show: function() {
        $.ch.addClass(this.loader, window.main.is_active_class)

        return this
    },

    hide: function() {
        $.ch.removeClass(this.loader, window.main.is_active_class)

        return this
    }
}